<header class="flex header">
  @if (site && site.id) {
    <h2>{{ 'Modal_Sites.Edit' | translate }}</h2>
  } @else {
    <h2>{{ 'Modal_Sites.Add' | translate }}</h2>
  }
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>
<section class="content">
  <form [formGroup]="fromGroup" class="col">
    <!-- Site Code -->
    <div class="form-box">
      <label for="code">
        {{ 'Modal_Sites.SiteCode' | translate }}
      </label>
      <input class="w-full" pInputText type="text" id="code" formControlName="code" />
    </div>
    <!-- Site Name -->
    <div class="form-box">
      <label for="name">
        {{ 'Modal_Sites.SiteName' | translate }}
      </label>
      <input class="w-full" pInputText type="text" id="name" formControlName="name" />
    </div>
    <!-- Description -->
    <div class="form-box">
      <label for="description">
        {{ 'Modal_Sites.Description' | translate }}
      </label>
      <textarea class="w-full" pTextarea id="description" formControlName="description"></textarea>
    </div>
    <!-- Country ID -->
    <div class="form-box">
      <label for="countryId">
        {{ 'Modal_Sites.CountryId' | translate }}
      </label>
      <input class="w-full" pInputText type="text" id="countryId" formControlName="countryId" />
    </div>
  </form>
</section>
<footer>
  <p-button class="w-full" [label]="'Save' | translate" (click)="onSave()" />
  <p-button class="w-full" [label]="'Cancel' | translate" variant="outlined" (click)="onClose()" />
</footer>
